import { useCommunication } from './CommunicationWrapper';

type QueueOperation = 'insert' | 'modify' | 'delete';

interface EventData {
    title: string;
    startDateTime: string;   // ISO string
    duration?: number;       // Minutes. If null/undefined → all-day event
    description?: string;
    type?: string;           // 'planned', 'due', 'custom', etc.
}

interface QueueItem {
    canvasId: string;
    operation: QueueOperation;
    eventData: EventData;
}

export const useCalendarQueue = () => {
    const { getOptions, updateOptions } = useCommunication();

    /**
     * Add item to calendar sync queue
     * Super simple: just add the raw execution data to the queue
     */
    const addToQueue = async (
        canvasId: string,
        operation: QueueOperation,
        eventData: EventData
    ) => {
        console.log('[CalendarQueue] Adding to queue:', { canvasId, operation, eventData });

        // Get current queue from local storage
        const local = getOptions('local');
        const unsyncedCalendar = [...(local?.unsynced_calendar || [])];

        // Build queue item - everything needed in one place
        const queueItem: QueueItem = {
            canvasId,
            operation,
            eventData
        };

        // Just add it - no checks, no lookups
        unsyncedCalendar.push(queueItem);

        // Write back to local storage
        updateOptions({ unsynced_calendar: unsyncedCalendar }, 'local');
        console.log('[CalendarQueue] Queue updated, length:', unsyncedCalendar.length);
    };

    return {
        addToQueue
    };
};
